var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,-1.1937118e-12 C7.3024,-1.1937118e-12 6.73684211,0.565536842 6.73684211,1.26315789 L6.73684211,6.73686316 L1.26315789,6.73686316 C0.565536842,6.73686316 0,7.30237895 0,8.00002526 C0,8.69762526 0.565536842,9.26318316 1.26315789,9.26318316 L6.73684211,9.26318316 L6.73684211,14.7368463 C6.73684211,15.4344674 7.3024,16 8,16 C8.69764211,16 9.26315789,15.4344674 9.26315789,14.7368463 L9.26315789,9.26318316 L14.7368421,9.26318316 C15.4344632,9.26318316 16,8.69762526 16,8.00002526 C16,7.30237895 15.4344632,6.73686316 14.7368421,6.73686316 L9.26315789,6.73686316 L9.26315789,1.26315789 C9.26315789,0.565536842 8.69764211,-1.1937118e-12 8,-1.1937118e-12 L8,-1.1937118e-12 Z",
    id: "Path",
    fill: "#00AEEF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.01c95451172d74634946b70118479eef.svg";
export { ForwardRef as ReactComponent };